import * as React from 'react';
import classNames from 'classnames';

export default function ChevronDown(props) {
    const { className, ...others } = props;
    return (
        <svg
            className={classNames('icon', className)}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            {...others}
        >
            <path
                d="M3.5 5.75L8 10.25L12.5 5.75"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
